export const GoogleMapApiConfig = 'AIzaSyAYS0N7aJKTB0iV3z0_ISkUHmLR1udnnQ0';